exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-list{overflow-y:scroll;height:70vh\n}\n#attendee-list{font-size:1.4rem\n}\n@media (max-width: 500px){\n#attendee-list input{font-size:1.2rem\n}\n}\n@media (max-width: 500px){\n#attendee-list article{font-size:1.1rem\n}\n}\n.attendees{padding-left:15px;padding-right:15px\n}\n.attendees .keyword{margin-bottom:10px\n}\n@media (max-width: 500px){\n.attendees .btn{font-size:1.2rem\n}\n}\n.attendees article{background:#f2f2f2;padding-top:5px;padding-bottom:5px;margin-bottom:5px;box-shadow:0 1px 0 0 rgba(0,0,0,0.1);display:flex;align-items:center\n}\n.attendees a.title{text-transform:uppercase\n}\n", ""]);

// exports
